import { FC } from "react";
import { CaseCreation, CaseStatus } from "types";

type Props = {
  caseData: CaseCreation;
};

const ChangeLog: FC<Props> = ({ caseData }) => {
  const logs = Array.isArray((caseData as any)?.change_logs)
    ? (caseData as any).change_logs
    : [];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200">
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center gap-3">
          <div className="w-2 h-8 bg-red-600 rounded-full"></div>
          <h3 className="text-lg font-semibold text-gray-900">Activity Log</h3>
        </div>
      </div>

      <div className="p-6 max-h-[500px] overflow-y-auto">
        {logs.length > 0 ? (
          <div className="space-y-4">
            {logs.map((log: any, idx: number) => {
              const dateObj = log.timestamp ? new Date(log.timestamp) : null;
              const day = dateObj ? dateObj.getDate() : "--";
              const month = dateObj
                ? dateObj.toLocaleString("default", { month: "short" })
                : "---";
              const year = dateObj ? dateObj.getFullYear() : "----";
              const time = dateObj
                ? dateObj.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : "--:--";

              let statusLabel = "";
              let statusColor = "bg-gray-100 text-gray-700";
              if (log.new_value && log.new_value in CaseStatus) {
                statusLabel =
                  CaseStatus[log.new_value as keyof typeof CaseStatus];
                if (statusLabel === "Approved")
                  statusColor = "bg-green-100 text-green-800";
                else if (statusLabel === "Rejected")
                  statusColor = "bg-red-100 text-red-800";
                else statusColor = "bg-gray-100 text-gray-700";
              }

              const nameRole = log.changed_by || "-";

              return (
                <div key={log.id} className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div className="w-12 h-12 bg-blue-50 rounded-lg flex flex-col items-center justify-center p-2">
                      <span className="text-xs font-semibold text-gray-600">
                        {month}
                      </span>
                      <span className="text-lg font-bold text-gray-900">
                        {day}
                      </span>
                      <span className="text-xs text-gray-500">{year}</span>
                    </div>
                    {idx !== logs.length - 1 && (
                      <div className="w-0.5 h-full bg-gray-200 mt-2"></div>
                    )}
                  </div>

                  <div className="flex-1 bg-gray-50 rounded-lg p-4 border border-gray-200">
                    <div className="flex items-center gap-3 mb-2">
                      {statusLabel && (
                        <span
                          className={`px-3 py-1 rounded-full text-xs font-medium ${statusColor}`}
                        >
                          {statusLabel}
                        </span>
                      )}
                      <span className="text-sm font-semibold text-gray-900">
                        {nameRole}
                      </span>
                    </div>

                    <div className="text-xs text-gray-500 mb-2">
                      {dateObj
                        ? dateObj.toLocaleDateString(undefined, {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                          })
                        : "-"}
                      {" • "}
                      {time}
                    </div>

                    {log.field_changed && (
                      <div className="text-sm text-gray-700">
                        <span className="font-medium text-gray-900">
                          {log.field_changed?.replace(/_/g, " ")}:
                        </span>
                        {log.old_value && (
                          <span className="ml-2">
                            Changed from{" "}
                            <span className="font-medium">
                              {log.old_value && log.old_value in CaseStatus
                                ? CaseStatus[
                                    log.old_value as keyof typeof CaseStatus
                                  ]
                                : log.old_value}
                            </span>
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">
            No activity logs found
          </div>
        )}
      </div>
    </div>
  );
};

export default ChangeLog;
